// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"76846203","874":"f42b4f15"}[chunkId] + ".chunk.js";
};